export interface Config {
  apiUrl: string;
  websocketUrl: string;
}

export enum Environment {
  LOCALHOST = 'localhost',
  DEV = 'dev',
  PRODUCTION = 'production',
}

const configByEnv: Record<string, Config> = {
  dev: {
    apiUrl: 'https://elife-api-dev.aiscloud.linkjapan.co.jp/api/elife',
    websocketUrl: 'https://chat-dev.linkjapan.co.jp',
  },
  production: {
    apiUrl: 'https://elife-api.aiscloud.linkjapan.co.jp/api/elife',
    websocketUrl: 'https://chat.linkjapan.co.jp',
  },
};

export const isDevEnvironment = (): boolean => {
  const host = window.location.host.toLowerCase();
  return (
    host.startsWith('localhost') || host.startsWith('medical-dev.homelink.jp')
  );
};

const loadConfigFromUrl = (): Config => {
  if (isDevEnvironment()) {
    return configByEnv.dev;
  }
  return configByEnv.production;
};

const load = (): Config => {
  const configFromUrl = loadConfigFromUrl();

  return {
    apiUrl: import.meta.env.VITE_HOMELINK_API_URL || configFromUrl.apiUrl,
    websocketUrl:
      import.meta.env.VITE_HOMELINK_SOCKET_IO_URL || configFromUrl.websocketUrl,
  };
};

export const CONFIG: Config = load();

export const DEFAULT_REFRESH_INTERVAL = 1000 * 30;
